export default __webpack_public_path__ + "static/media/IMG-20240729-WA0027.97ee7088.jpg";